import React from "react";

export default function ValentineFrame2({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 2000 2000"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls2-2{fill:#e98ead}.cls2-3{fill:#fea1bf}"}</style>
        </defs>
        <g
          id="\u0421\u043B\u043E\u0439_2"
          data-name="\u0421\u043B\u043E\u0439 2"
        >
          <path
            d="M1497 1594.35H509.68A100.79 100.79 0 0 1 409 1493.67V506.33a100.79 100.79 0 0 1 100.68-100.68H1497a100.79 100.79 0 0 1 100.7 100.68v987.34a100.79 100.79 0 0 1-100.7 100.68ZM509.68 425.65A80.77 80.77 0 0 0 429 506.33v987.34a80.77 80.77 0 0 0 80.67 80.68H1497a80.77 80.77 0 0 0 80.67-80.68V506.33a80.77 80.77 0 0 0-80.67-80.68Z"
            style={{
              fill: "#3a4f7a",
            }}
          />
          <path
            className="cls2-2"
            d="M1382 229.74c13.6-23.75 46.31-50.8 86.45-51.65 35.82-.75 70.59 19.52 93.93 53 32.89-24.2 72.34-32.18 106-19.92 37.73 13.73 60 49.88 65.2 76.74 13.69 70.38-72.82 162.93-217.8 225.43h-.24C1398.46 407.43 1346.39 292 1382 229.74Z"
          />
          <path
            className="cls2-3"
            d="M1166.12 531.55c1.3-16.68 12.28-40.18 34.23-51.16 19.59-9.79 44.1-7.7 65.76 4.69 11.83-22 31.54-36.7 53.34-38.75 24.43-2.29 46.19 11.86 56.1 25.32 26 35.3 2.43 109.06-61.29 181.54h-.14c-92.4-27.79-151.4-77.94-148-121.64ZM1158.84 267.22c5-11.16 18.42-24.63 36.26-26.74 15.92-1.89 32.29 5.63 44.13 19.54 13.6-12.2 30.83-17.46 46.35-13.46 17.39 4.49 28.87 19.62 32.36 31.36 9.14 30.75-25.38 75.71-87.25 109.83h-.1c-56.74-42.1-84.93-91.28-71.75-120.53Z"
          />
          <path
            className="cls2-2"
            d="M618 1398.43c-13.6-23.74-46.31-50.8-86.45-51.64-35.82-.76-70.59 19.51-93.93 53-32.89-24.19-72.34-32.17-106-19.92-37.73 13.74-60 49.89-65.2 76.74-13.69 70.39 72.82 162.93 217.8 225.44h.24c117.08-105.92 169.15-221.4 133.54-283.62Z"
          />
          <path
            className="cls2-3"
            d="M833.88 1700.24c-1.3-16.67-12.28-40.18-34.23-51.15-19.59-9.8-44.1-7.71-65.76 4.69-11.83-22-31.54-36.71-53.34-38.75-24.43-2.29-46.19 11.85-56.1 25.32-26 35.29-2.43 109.06 61.29 181.54h.14c92.4-27.8 151.4-77.95 148-121.65ZM841.16 1435.91c-5-11.16-18.42-24.62-36.26-26.74-15.92-1.88-32.29 5.64-44.13 19.55-13.6-12.2-30.83-17.46-46.35-13.46-17.39 4.48-28.87 19.62-32.36 31.35-9.14 30.76 25.38 75.72 87.25 109.83h.1c56.74-42.1 84.93-91.27 71.75-120.53Z"
          />
        </g>
        {children}
      </g>
    </svg>
  );
}
